import React from "react";

const BookingHeader = ({ title = "Seat Management", subtitle = "Booking Layout" }) => (
  <div className="mb-6 rounded-[24px] border border-slate-800 bg-black p-6 shadow-sm flex items-center justify-between">
    <div>
      <p className="text-xs font-medium uppercase tracking-[0.18em] text-slate-400">
        {subtitle}
      </p>
      <h1 className="mt-2 text-2xl font-semibold text-white">
        {title}
      </h1>
    </div>

  </div>
);

export default BookingHeader;
